<!--
 * @Author: hucaili hucaili@qfei.cn
 * @Date: 2023-06-06 15:29:49
 * @LastEditors: jiaxiuc
 * @LastEditTime: 2024-04-01
 * @FilePath: /fe-crm/src/components/default/xl-schedule/xl-schedule.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="page-client-calendar-trip">
    <special-head :title="$t('未完成日程')">
      <template #extra>
        <jw-button v-if="showAddButton" type="text" size="small" @click="addEditNewTrip('add')" class="calendar-handle-btn">
          <qfei-icon-add-two-outlined />
          {{ $t('新建') }}
        </jw-button>
      </template>
    </special-head>
    <div class="undone-trip">
      <jw-spin v-if="loading" :tip="$t('数据加载中') + '……'" class="spin-loading"> </jw-spin>
      <template v-if="undoneList?.length > 0">
        <div class="undone-trip-item" v-for="(item, index) in undoneList" :key="item.id">
          <special-card>
            <template #title>
              <div class="undone-trip-item-title">
                <template v-if="[1, 2, 3].includes(type) && permission == 1">
                  <jw-checkbox v-model="item.checked" class="undone-checkbox" @change="addFollow(index, item)" :disabled="!item?.isShowEdit"></jw-checkbox>
                </template>

                <span class="undone-text" :title="item?.calenderItem">{{ item?.calenderItem || '-' }}</span>
              </div>
            </template>
            <template #more>
              <div class="undo-trip-more">
                <span class="green-orange">
                  <!-- <jw-tag :color="item.statusName === '进行中' ? 'green' : item.statusName === '未开始' ? 'orange' : 'blue'" bordered>{{ item.statusName }}</jw-tag> -->

                  <!-- 0 未开始 orange -->
                  <!-- 1 进行中 green -->
                  <!-- 2 已结束 grey -->

                  <xl-dot :color="item.status === '1' ? 'green' : item.status === '0' ? 'orange' : 'grey'" :title="item.status === '1' ? $t('进行中') : item.status === '0' ? $t('未开始') : $t('已结束')"></xl-dot>
                </span>

                <jw-dropdown>
                  <jw-button type="text" size="small" class="handle-btn-more"><qfei-icon-more-applications-outlined /></jw-button>
                  <template #content>
                    <jw-doption v-if="item?.isShowEdit && userInfo?.roles?.indexOf(`${permissionPrefix}:editSchedule`) !== -1 && permission == 1 && buttons.indexOf(`${permissionPrefix}:editSchedule`) > -1" size="small" class="edit-delete-edit" @click="addEditNewTrip('edit', item)">
                      {{ $t('修改') }}
                    </jw-doption>
                    <jw-doption v-if="item?.isShowEdit && userInfo?.roles?.indexOf(`${permissionPrefix}:delSchedule`) !== -1 && permission == 1 && buttons.indexOf(`${permissionPrefix}:delSchedule`) > -1" size="small" class="edit-delete-delete" @click="deleteNewTrip(item)">
                      {{ $t('删除') }}
                    </jw-doption>
                  </template>
                </jw-dropdown>
              </div>
            </template>

            <div class="undone-trip-content">
              <div class="content-item">
                <span class="content-item-label">{{ $t('方式') }}：</span>{{ pitchTypeObj[item.pitchInType] || '-' }}
              </div>
              <div class="content-item">
                <span class="content-item-label">{{ $t('时间') }}：</span> {{ item.startTime ? dayjs(item.startTime).format('MM-DD HH:mm') : '-' }}~{{ item.endTime ? dayjs(item.endTime).format('HH:mm') : '-' }}
              </div>
              <jw-link v-if="item.videoUrl" @click.stop.prevent="useUrlAddUser(item, 1)">
                <template #icon>
                  <qf-icon-fei-shu-minutes />
                </template>
                {{ $t('会议妙记') }}
              </jw-link>
              <div class="content-item person-item">
                <span class="content-item-label">{{ $t('创建人') }}：</span>
                <xl-avatar v-if="item.userName" :avatar="{ name: item?.userName || '', url: item?.avatar, id: item?.createUser }" :size="20" />
                <template v-else>-</template>
              </div>
            </div>
          </special-card>
        </div>
      </template>
      <template v-else>
        <jw-empty v-if="!loading" class="eltimeline" :img-src="imgSvg"> {{ $t('暂无日程，可新建日程') }} </jw-empty>
      </template>
    </div>

    <special-head :title="$t('已完成日程')" />

    <div class="done-trip">
      <jw-spin v-if="loading" :tip="$t('数据加载中') + '……'" class="spin-loading"> </jw-spin>
      <template v-if="doneList?.length > 0">
        <div class="done-trip-item" v-for="item in doneList" :key="item.id">
          <special-card>
            <template #title>
              <span class="done-trip-item-right-title-span" :title="item?.calenderItem">
                {{ item?.calenderItem || '-' }}
              </span>
            </template>
            <template #more>
              <xl-dot color="grey" :title="$t('已结束')"></xl-dot>
            </template>
            <div class="undone-trip-content">
              <div class="content-item">
                <span class="content-item-label">{{ $t('方式') }}：</span>{{ pitchTypeObj[item.pitchInType] || '-' }}
              </div>

              <jw-link v-if="item.videoUrl" @click.stop.prevent="useUrlAddUser(item, 1)">
                <template #icon>
                  <qf-icon-fei-shu-minutes />
                </template>
                {{ $t('会议妙记') }}
              </jw-link>

              <div class="content-item">
                <span class="content-item-label">{{ $t('创建人') }}：</span>
                <xl-avatar v-if="item.userName" :avatar="{ name: item?.userName || '', url: item?.avatar, id: item?.createUser }" :size="22" />
                <template v-else>-</template>
              </div>
              <div class="content-item">
                <span class="content-item-label">{{ $t('时间') }}：</span> {{ item.startTime ? dayjs(item.startTime).format('MM-DD HH:mm') : '-' }}~{{ item.endTime ? dayjs(item.endTime).format('HH:mm') : '-' }}
              </div>
            </div>
          </special-card>
        </div>
      </template>
      <template v-else>
        <jw-empty v-if="!loading" class="eltimeline" :img-src="imgSvg"> {{ $t('暂无已完成日程') }} </jw-empty>
      </template>
    </div>

    <!-- 新建日程 -->
    <xl-update-schedule ref="updatescheduleRef" @cb="getCalenderDetail"></xl-update-schedule>
    <!-- 弹窗打开 E -->
    <fh-add-edit ref="addEditRefR" @cb="loadTList" @cbCancel="checkCancel" />
  </div>
</template>

<script>
import { reactive, toRefs, ref, computed, onMounted, inject, watchEffect } from 'vue';
import { Modal } from '@arco-design/web-vue';
import { useRoute } from 'vue-router';
import dayjs from 'dayjs';
import imgSvg from '@/assets/images/no-schedule.svg';
import useLoading from '@/hooks/loading';
import { useUserStore, useScheduleStore } from '@/store';
import { followTypeObj, hyzbFollowTypeObj, huaYingOrdId } from '@/utils/const';
import useUrlAddUser from '@/hooks/video-add-user';
import { useI18n } from 'vue-i18n';
import { layoutService, calendarService } from '@/api/';
import { Message } from '@arco-design/web-vue';
import SpecialCard from '@/components/fh-detail/components/special-card/index.vue';
import SpecialHead from '@/components/fh-detail/components/special-head/index.vue';
export default {
  name: 'XlSchedule',
  props: {
    moduleId: {
      type: String,
      default: ''
    },
    followRecordIsShow: {
      type: String,
      default: ''
    }
  },
  components: {
    SpecialCard,
    SpecialHead
  },
  setup(props, { emit }) {
    const { t } = useI18n();
    const updatescheduleRef = ref(); //新建日程
    const route = useRoute();
    const { userInfo } = useUserStore();
    const useSchedule = useScheduleStore(); //日程store
    const { loading, setLoading } = useLoading(true);
    setLoading(false);
    const data = reactive({
      undoneList: [],
      undoneListIndex: null, // 数组类型改为null，为下标使用
      doneList: [],
      pitchTypeObj: userInfo?.orgId != huaYingOrdId ? followTypeObj : hyzbFollowTypeObj,
      id: inject('detailParams').id, //客户id
      type: inject('detailParams').entity, //模块标识
      permission: inject('detailParams')?.permission, //权限
      followUserId: inject('detailParams')?.followUserId, //跟进人id
      customerId: inject('detailParams')?.customerId //是否展示编辑
    });

    console.log('沟通方式333', data.pitchTypeObj);

    // 根据 type 映射权限前缀
    const permissionPrefix = computed(() => {
      const map = {
        1: 'clue',
        2: 'customer',
        3: 'businessOpportunity'
      };
      return map[data.type] || '';
    });

    // 判断是否显示新建按钮
    const showAddButton = computed(() => {
      if (!permissionPrefix.value || data.permission !== 1) {
        return false;
      }
      const permissionKey = `${permissionPrefix.value}:addSchedule`;
      return buttons.value.includes(permissionKey) && userInfo?.roles?.includes(permissionKey);
    });

    const addEditRefR = ref();
    // 新建或编辑日程--打开新建日程弹窗
    const addEditNewTrip = (type, record) => {
      console.log('新建或编辑日程', type, record);
      const params = {
        controlsType: type, //add,edit
        ...record,
        typeTitle: type == 'add' ? t('新建日程') : t('编辑日程'),
        sourceType: 'schedule'
      };
      updatescheduleRef.value?.updateScheduleShow(params);
      // 第一个参数1代表从线索详情中的日程页签跳转过去的
      // newTripRef.value.open(1, type, record);
    };
    const loadTList = () => {
      emit('cbx');
      getCalenderDetail();
    };
    // 添加动态记录
    const addFollow = async (v, record) => {
      data.undoneListIndex = v;

      if (props.followRecordIsShow == 1 || props.followRecordIsShow == 2) {
        if (userInfo?.roles?.indexOf('dynamicRecord:view') !== -1 && userInfo?.roles?.indexOf('dynamicRecord:add') !== -1) {
          const params = { id: '', type: 30, viewId: -1, entity: 16, copy: 0, scheduleObj: { isSchedule: true, followStartTime: record.startTime, calenderId: record.calenderId, calenderEventId: record.eventId, taskId: record.taskId }, followObj: { isSourceDetailStatus: true, sourceEntity: data.type, sourceId: data.id } };
          addEditRefR.value?.open(params);
          return;
        }
      }
      try {
        const json = await calendarService.done({ calenderId: record.calenderId, calenderEventId: record.eventId, taskId: record.taskId });
        if (!json.error) {
          await getCalenderDetail();
          Message.success('操作成功');
        } else {
          Message.error(json.error?.msg || t('操作失败'));
        }
      } catch (e) {
        Message.error(e.msg || t('操作失败'));
      }
    };
    // 取消复选框
    const checkCancel = () => {
      // 先检查 undoneList 是否为有效的数组，并且 undoneListIndex 在有效范围内
      if (data.undoneListIndex !== null && data.undoneListIndex >= 0 && data.undoneListIndex < data.undoneList.length) {
        data.undoneList[data.undoneListIndex].checked = false;
      }
    };
    // 删除某一条日程
    const deleteNewTrip = (record) => {
      console.log('移除角色调移除接口', record);
      Modal.confirm({
        titleAlign: 'start',
        width: 400,
        simple: false,
        title: t('确认移除该日程？'),
        content: t('tips.confimShedule'),
        onOk: () => {
          deleteCalender(record); //改为删除角色管理员接口
        }
      });
    };
    // 日程删除接口
    const deleteCalender = async (row) => {
      const params = {
        id: row.id,
        eventId: row.eventId,
        taskId: row.taskId,
        calenderId: row.calenderId
      };
      useSchedule.deleteCalender(params, getCalenderDetail);
    };
    //  获取日程列表
    const getCalenderDetail = async () => {
      console.log(160, data.id);
      data.undoneList = [];
      data.doneList = [];
      setLoading(true);
      const params = {
        id: data.id,
        type: data.type
      };
      await useSchedule
        .getScheduleList(params)
        .then((res) => {
          const nofinishDetail = [];
          res.result?.nofinishDetail?.forEach((item) => {
            nofinishDetail.push({ ...item, checked: false });
          });
          data.undoneList = nofinishDetail;
          data.doneList = res.result?.finishDetail;
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          // Message.error(err.message || err.statusText || '日程数据获取失败');
        })
        .finally(() => {
          setLoading(false);
        });
    };

    // 列表加载完成后根据scheduleId找对应的那一条数据
    const schedule = () => {
      const tab = route.query?.tab;
      const scheduleId = route.query?.scheduleId;
      const scheduleItem = data.undoneList?.find((v) => v.id === scheduleId);
      if (tab === 'calendarTrip' && scheduleId && scheduleItem) {
        const params = { id: '', type: 30, viewId: -1, entity: 16, copy: 0, scheduleObj: { isSchedule: true, followStartTime: scheduleItem.startTime, calenderId: scheduleItem.calenderId, calenderEventId: scheduleItem.eventId, taskId: scheduleItem.taskId }, followObj: { isSourceDetailStatus: true, sourceEntity: data.type, sourceId: data.id } };
        addEditRefR.value?.open(params);
        return;
      }
    };

    onMounted(async () => {
      await getCalenderDetail();
      schedule();
      getDetail();
    });
    const buttons = ref([]);
    const getDetail = async () => {
      if (!props?.moduleId) {
        return false;
      }
      try {
        const params = {
          entity: data.type,
          moduleId: props.moduleId,
          businessId: data.id
        };
        const json = await layoutService.getDetail(params);
        if (!json.error) {
          const _buttons = [];
          json?.result?.map((b) => {
            _buttons.push(b.value);
          });
          buttons.value = _buttons;
        }
      } catch (e) {
        console.log(e);
      }
    };
    watchEffect(() => {
      data.doneList = useSchedule.finishDetail;
      const v = useSchedule.nofinishDetail;
      const nofinishDetail = [];
      v?.forEach((item) => {
        nofinishDetail.push({ ...item, checked: false });
      });
      data.undoneList = nofinishDetail;
    });
    return {
      addEditRefR,
      loadTList,
      addFollow,
      imgSvg,
      loading,
      userInfo,
      deleteNewTrip,
      checkCancel,
      addEditNewTrip,
      useUrlAddUser,
      getCalenderDetail,
      updatescheduleRef,
      dayjs,
      buttons,
      hyzbFollowTypeObj,
      showAddButton,
      permissionPrefix,
      ...toRefs(data)
    };
  }
};
</script>

<style scoped lang="less">
@import './xl-schedule.less';
</style>
